import workspaceQuery from '../../queries/vat/VatReturnWorkspaceQuery.graphql';
import instanceQuery from '../../queries/vat/VatReturnQuery.graphql';
import defaultQuery from '../../queries/vat/VatReturnDefault.graphql';
import mutationQuery from '../../mutations/vat/VatReturnMutation.graphql';
import fragment from '../../fragments/vat/VatReturnFragment.graphql';
import { ALLOW_ADD, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const VatReturn: EntityType = {
  type: 'VatReturn',
  title: 'VAT Return',
  formTitle: 'VAT Return',
  formUrl: '/Vat/Return/Details/',
  workspaceUrl: '/Vat/Return/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  fragment,
  screenReference: 'VAT_RETURN',
  operations: ALLOW_ADD | ALLOW_VIEW,
};

export default VatReturn;
